/**
* @description: 消息管理（系统通知和公告）
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div class="btn_box">
            <el-button type="primary" @click="openAdd">{{ t('messageAdmin.addBtn') }}</el-button>
        </div>
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #type="{ row }">
                    <el-tag :type="typeTagMap[row.type]" size="small">{{ listToMap(typeOptions, {})[row.type] || '-' }}</el-tag>
                </template>
                <template #content="{ row }">
                    <div class="content-cell">{{ row.content || '-' }}</div>
                </template>
                <template #created_at="{ row }">
                    {{ formatDateTime(row.created_at) }}
                </template>
                <template #operation="{ row }">
                    <el-button 
                        class="opBtn" 
                        size="small" 
                        type="primary" 
                        link
                        @click="openEdit(row)"
                    >{{ t('common.edit') }}</el-button>
                    <el-button 
                        class="opBtn" 
                        size="small" 
                        type="danger" 
                        link
                        @click="handleDelete(row)"
                    >{{ t('common.delete') }}</el-button>
                </template>
            </hc-table>
        </div>
        <!-- 添加/编辑弹窗 -->
        <MessageDialog ref="messageDialog" :title="state.dialogTitle" :row="state.row" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import MessageDialog from "./components/MessageDialog.vue";
import { getMessageListApi } from "@/api/message";
import { listToMap } from "@/utils/utils";
import { ElMessage, ElMessageBox } from 'element-plus';
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyMessageListLabels } from "@/utils/messageListI18n.js";
import { formatDisplayDateTime } from "@/utils/dateTime.js";

const myElementRef = ref();
const searchBox = ref();
const messageDialog = ref();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const typeOptions = reactive([
    { label: "系统通知", value: 1 },
    { label: "提醒", value: 2 },
    { label: "公告", value: 3 },
]);

const typeTagMap = {
    1: 'info',
    2: 'warning',
    3: 'success',
}

const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
    {
        label: "消息类型",
        type: "select",
        value: "",
        defaultValue: "",
        field: 'type',
        children: [
            { label: "全部", value: "" },
            ...typeOptions
        ],
        clearable: true
    },
]);

const state = reactive({
	loading: false,
    dialogTitle: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "ID",
        },
        {
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "type",
            show: true,
            label: "消息类型",
            width: 120,
        },
        {
            prop: "title",
            show: true,
            label: "标题",
        },
        {
            prop: "content",
            show: true,
            label: "内容",
            minWidth: 200,
        },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
            width: 180,
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 150,
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [],
    row: {}
});

const applyLabels = () => {
    applyMessageListLabels({ searchData, columns: state.column, typeOptions });
    tableHeaderFn();
};
const { t } = usePageI18n(applyLabels);

const init = () => {
    getSearch(searchData)
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

const openAdd = () => {
    state.dialogTitle = t('messageAdmin.add');
    state.row = {};
    messageDialog.value.open();
};

const openEdit = (row) => {
    state.dialogTitle = t('messageAdmin.edit');
    state.row = { ...row };
    messageDialog.value.open();
};

const handleDelete = (row) => {
    ElMessageBox.confirm(
        t('messageAdmin.deleteConfirm'),
        t('messageAdmin.deleteTitle'),
        {
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel'),
            type: 'warning',
        }
    ).then(() => {
        ElMessage.warning(t('messageAdmin.deleteNeedBackend'));
    }).catch(() => {});
};

// 格式化日期时间（接口层已统一处理，此处兜底展示）
const formatDateTime = (dateTime) => {
    if (!dateTime) return '-';
    return formatDisplayDateTime(dateTime) || '-';
};

// 查询数据
const getSearch = (params) => {
    params.forEach(i => i.value = i.value || '')
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		getMessageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        applyLabels();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
    margin-bottom: 10px;
}

.table_box {
    width: 100%;
}

.content-cell {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.opBtn {
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
